module.exports = __webpack_public_path__ + "img/Cooperation.4065a137.svg";